export const REFERRING_PHYSICIAN_OPTIONS = {
  FULL_NAME: "Patient.ReferringPhysician.FullName",
  FIRST_NAME: "Patient.ReferringPhysician.FirstName",
  LAST_NAME: "Patient.ReferringPhysician.LastName",
  NPI: "Patient.ReferringPhysician.NPI",
  EMAIL: "Patient.ReferringPhysician.Email",
  PHONE: "Patient.ReferringPhysician.Phone",
  FAX_NUMBER: "Patient.ReferringPhysician.FaxPhone",
  PRACTICE_NAME: "Patient.ReferringPhysician.PracticeName",
  ADDRESS: "Patient.ReferringPhysician.Address"
};
